export const PublicRefIdSlugUtil = {
  sanitizeId(id?: string) {
    if (!id) return null;
    return /-\d{6,}$/.test(id) ? id.split('-').pop() : id;
  },
};
